<ion-card class="card">
  <div class="card__content">
    <ion-card-header class="card__header">
      <ion-card-title class="card__header-title">Datos de contacto</ion-card-title>
    </ion-card-header>
    <ion-card-content class="card__description">
      <!-- @for (item of manager.phone; track $index) {
        <p>Télefono {{ $index }}: {{item + 1}}</p>
      } -->
      <p><span class="card__strong-text">Name:</span> {{manager.name}}</p>
      <p><span class="card__strong-text">Télefono 1:</span> {{manager.mobilePhone}}</p>
      <p><span class="card__strong-text">Correo electrónico:</span> {{ manager.email }}</p>
    </ion-card-content>
  </div>

  <div class="card__footer">
      <ion-button color="danger" (click)="delete()">
      Eliminar</ion-button>
  </div>
</ion-card>
